// extracted by mini-css-extract-plugin
export default {"notFound":"check_notFound__wmklR","chartWrapper":"check_chartWrapper__xyHxr","warning":"check_warning__mtg42"};